module.exports = __webpack_public_path__ + "img/1440.24d746c7.jpg";